
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexq3A4oq5szBBayL45FjsUdwyQOLfSdPN2jwzwvh77yu4Meta } from "/app/packages/frontend-usagers/src/pages/index.vue?macro=true";
import { default as listeHPPc18ue5ZlUoRleNygYoeqRdXlg8YU86L8_45MyZD_45CgMeta } from "/app/packages/frontend-usagers/src/pages/eig/liste.vue?macro=true";
import { default as cgud1lBE5InF2ilxpW_4533CKy2ak4WTSQiaz7uOIKnEvrIwMeta } from "/app/packages/frontend-usagers/src/pages/footer/cgu.vue?macro=true";
import { default as mon_45comptehMCCu6cxCbmfJSKHsuVWtlRmLmm6TJMFSsU2vcpsuT4Meta } from "/app/packages/frontend-usagers/src/pages/mon-compte.vue?macro=true";
import { default as _91_91eigId_93_93anv0EuJ8Jcn3C31xqSpop7B1hO3dtCZy2iu0LduUWKsMeta } from "/app/packages/frontend-usagers/src/pages/eig/[[eigId]].vue?macro=true";
import { default as indexsZu5o_osXYjoiaJuRFhwJbAXkQ706whnrjFW00_kp70Meta } from "/app/packages/frontend-usagers/src/pages/connexion/index.vue?macro=true";
import { default as indexpvwR_ALklF_45IX8_1iSwspj3CKI6KxRcv5sl_45fty6_45ycMeta } from "/app/packages/frontend-usagers/src/pages/messagerie/index.vue?macro=true";
import { default as bienvenueqM85AleupXkR7ITNybgQtjoyo7ZRxSMyUGqHGMG5V1wMeta } from "/app/packages/frontend-usagers/src/pages/agrement/bienvenue.vue?macro=true";
import { default as _91_91userId_93_93cMnpg0c_81jRkM6K9JZ98JipXF5m9z5WUe0K3omtKpwMeta } from "/app/packages/frontend-usagers/src/pages/comptes/[[userId]].vue?macro=true";
import { default as liste03aK3HfI5g3VdZQ0dWWOZzucB92zORVKIMP4uXA6aEoMeta } from "/app/packages/frontend-usagers/src/pages/hebergements/liste.vue?macro=true";
import { default as indexG4e4IJsdxA_45pEfbf7zN_eP3Z8LOJWkdzR_45s6a_mLw18Meta } from "/app/packages/frontend-usagers/src/pages/mon-agrement/index.vue?macro=true";
import { default as listeDCEoyYS6MbpgNiMhv1XIrGMjfP_45X9frA5eexl_45Fxd9sMeta } from "/app/packages/frontend-usagers/src/pages/utilisateurs/liste.vue?macro=true";
import { default as validation2Fi3JTV79gFoTIn6aoFZyvDokym4YGY46GmL1kLC3NkMeta } from "/app/packages/frontend-usagers/src/pages/connexion/validation.vue?macro=true";
import { default as listeHag_2jn78nlNe8E3sxRzczoxuyGtwVcbmvydOrjd_45vkMeta } from "/app/packages/frontend-usagers/src/pages/demande-sejour/liste.vue?macro=true";
import { default as accessibilite2rzV8yVcqraLhK15QA0W_45XfwxbHq15odMk4jyEdBU9gMeta } from "/app/packages/frontend-usagers/src/pages/footer/accessibilite.vue?macro=true";
import { default as gestion_45cookiesqMJGJLDV_TtqTqrsLGLxOjWL48l0kZbSPXzbMVuPl4wMeta } from "/app/packages/frontend-usagers/src/pages/footer/gestion-cookies.vue?macro=true";
import { default as _91_91agrementId_93_93_xviN19xFerc6X164hDxex2_45uDDbZ7NV3Ze7FFsZJoEMeta } from "/app/packages/frontend-usagers/src/pages/agrement/[[agrementId]].vue?macro=true";
import { default as mentions_45legalesTfSQMk9drJOaYMqn4aXt1s451_I_458xPDRpoyfNn2UIYMeta } from "/app/packages/frontend-usagers/src/pages/footer/mentions-legales.vue?macro=true";
import { default as enregistrementHAn7u4Kh0p5D7BtGffbePQbgU6g3I5SOQ1BYrGBgToEMeta } from "/app/packages/frontend-usagers/src/pages/connexion/enregistrement.vue?macro=true";
import { default as _91_91organismeId_93_93fL4r7ur_452ySG55kAhFHJg60cKiDtm8B5vAYXIgrpXnIMeta } from "/app/packages/frontend-usagers/src/pages/organisme/[[organismeId]].vue?macro=true";
import { default as verification_45otp7Ce2udjJFiNv19sM8dAUCkJlJbySNlsSFQTpyBMwE7IMeta } from "/app/packages/frontend-usagers/src/pages/connexion/verification-otp.vue?macro=true";
import { default as donnees_45personnelles8B4jm_45hKxraVMMx03_453R_45fJluN6_452F0BRNTSV8tUzoUMeta } from "/app/packages/frontend-usagers/src/pages/footer/donnees-personnelles.vue?macro=true";
import { default as reset_45mot_45de_45passeszL0wbq_45xOLu_45oC1phHQr9OiBjw_So7J8gFPOPVl9yIMeta } from "/app/packages/frontend-usagers/src/pages/connexion/reset-mot-de-passe.vue?macro=true";
import { default as mot_45de_45passe_45oublieA8hhlvCf4QNPxFEDBRe0MP8ewSqJ5bapl9ajpg10rxEMeta } from "/app/packages/frontend-usagers/src/pages/connexion/mot-de-passe-oublie.vue?macro=true";
import { default as _91_91hebergementId_93_93BQThh8ApDZgHJP7V_5yRCi30QNZNY8MrVqfDQFWOskQMeta } from "/app/packages/frontend-usagers/src/pages/hebergements/[[hebergementId]].vue?macro=true";
import { default as indexMCy_45rLakxG9cJ0bRXZOvIgU25NiSZ1U1OrmUNy_45WjkIMeta } from "/app/packages/frontend-usagers/src/pages/demande-agrement-transmise/index.vue?macro=true";
import { default as _91_91declarationId_93_93pGPuOgmes3iNwXjez7YN2NoDuivsAneGwrPHz0GZOjYMeta } from "/app/packages/frontend-usagers/src/pages/demande-sejour/[[declarationId]].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["is-connected","check-first-agrement"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/index.vue")
  },
  {
    name: "eig-liste",
    path: "/eig/liste",
    meta: {"middleware":["is-connected","check-roles"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/eig/liste.vue")
  },
  {
    name: "footer-cgu",
    path: "/footer/cgu",
    component: () => import("/app/packages/frontend-usagers/src/pages/footer/cgu.vue")
  },
  {
    name: "mon-compte",
    path: "/mon-compte",
    meta: {"middleware":["is-connected"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/mon-compte.vue")
  },
  {
    name: "eig-eigId",
    path: "/eig/:eigId?",
    meta: {"middleware":["is-connected","check-roles","check-eig-id-param"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/eig/[[eigId]].vue")
  },
  {
    name: "connexion",
    path: "/connexion",
    component: () => import("/app/packages/frontend-usagers/src/pages/connexion/index.vue")
  },
  {
    name: "messagerie",
    path: "/messagerie",
    meta: {"middleware":["is-connected","check-organisme-is-complet"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/messagerie/index.vue")
  },
  {
    name: "agrement-bienvenue",
    path: "/agrement/bienvenue",
    meta: {"middleware":["is-connected","check-organisme-is-complet","check-no-agrement-existing"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/agrement/bienvenue.vue")
  },
  {
    name: "comptes-userId",
    path: "/comptes/:userId?",
    component: () => import("/app/packages/frontend-usagers/src/pages/comptes/[[userId]].vue")
  },
  {
    name: "hebergements-liste",
    path: "/hebergements/liste",
    component: () => import("/app/packages/frontend-usagers/src/pages/hebergements/liste.vue")
  },
  {
    name: "mon-agrement",
    path: "/mon-agrement",
    meta: {"middleware":["is-connected","check-organisme-is-complet","check-feature-flags"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/mon-agrement/index.vue")
  },
  {
    name: "utilisateurs-liste",
    path: "/utilisateurs/liste",
    component: () => import("/app/packages/frontend-usagers/src/pages/utilisateurs/liste.vue")
  },
  {
    name: "connexion-validation",
    path: "/connexion/validation",
    component: () => import("/app/packages/frontend-usagers/src/pages/connexion/validation.vue")
  },
  {
    name: "demande-sejour-liste",
    path: "/demande-sejour/liste",
    component: () => import("/app/packages/frontend-usagers/src/pages/demande-sejour/liste.vue")
  },
  {
    name: "footer-accessibilite",
    path: "/footer/accessibilite",
    component: () => import("/app/packages/frontend-usagers/src/pages/footer/accessibilite.vue")
  },
  {
    name: "footer-gestion-cookies",
    path: "/footer/gestion-cookies",
    component: () => import("/app/packages/frontend-usagers/src/pages/footer/gestion-cookies.vue")
  },
  {
    name: "agrement-agrementId",
    path: "/agrement/:agrementId?",
    meta: {"middleware":["is-connected","check-organisme-is-complet","check-feature-flags","load-agrement-context","check-agrement-readonly-statut"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/agrement/[[agrementId]].vue")
  },
  {
    name: "footer-mentions-legales",
    path: "/footer/mentions-legales",
    component: () => import("/app/packages/frontend-usagers/src/pages/footer/mentions-legales.vue")
  },
  {
    name: "connexion-enregistrement",
    path: "/connexion/enregistrement",
    component: () => import("/app/packages/frontend-usagers/src/pages/connexion/enregistrement.vue")
  },
  {
    name: "organisme-organismeId",
    path: "/organisme/:organismeId?",
    meta: {"middleware":["is-connected","check-organisme-id-param"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/organisme/[[organismeId]].vue")
  },
  {
    name: "connexion-verification-otp",
    path: "/connexion/verification-otp",
    component: () => import("/app/packages/frontend-usagers/src/pages/connexion/verification-otp.vue")
  },
  {
    name: "footer-donnees-personnelles",
    path: "/footer/donnees-personnelles",
    component: () => import("/app/packages/frontend-usagers/src/pages/footer/donnees-personnelles.vue")
  },
  {
    name: "connexion-reset-mot-de-passe",
    path: "/connexion/reset-mot-de-passe",
    component: () => import("/app/packages/frontend-usagers/src/pages/connexion/reset-mot-de-passe.vue")
  },
  {
    name: "connexion-mot-de-passe-oublie",
    path: "/connexion/mot-de-passe-oublie",
    component: () => import("/app/packages/frontend-usagers/src/pages/connexion/mot-de-passe-oublie.vue")
  },
  {
    name: "hebergements-hebergementId",
    path: "/hebergements/:hebergementId?",
    meta: {"middleware":["is-connected","check-hebergement-id-param"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/hebergements/[[hebergementId]].vue")
  },
  {
    name: "demande-agrement-transmise",
    path: "/demande-agrement-transmise",
    component: () => import("/app/packages/frontend-usagers/src/pages/demande-agrement-transmise/index.vue")
  },
  {
    name: "demande-sejour-declarationId",
    path: "/demande-sejour/:declarationId?",
    meta: {"middleware":["is-connected","check-organisme-is-complet","check-demande-sejour-id-param"]},
    component: () => import("/app/packages/frontend-usagers/src/pages/demande-sejour/[[declarationId]].vue")
  }
]